import React from 'react';
import { Icon } from '../Icon/Icon';
import { resumeTeam, useTeamHold } from '../../team-hold/teamHold';

/**
 * The held banner (amendment 32 §6) — shown on /ai-team, every agent page and
 * the Dashboard while the whole team is held. Reads the shared team-hold store,
 * so it appears everywhere the moment Hold the whole team is confirmed.
 */
export function TeamHoldBanner() {
  const s = useTeamHold();
  if (!s.held) return null;
  return (
    <div
      role="status"
      className="mx-auto flex w-full max-w-[1084px] flex-wrap items-center gap-3 rounded-[var(--r-lg)] border border-[color-mix(in_srgb,var(--terracotta)_35%,transparent)] bg-[var(--terracotta-tint)] px-4 py-3"
    >
      <Icon kind="pause" size={15} stroke={2} style={{ color: 'var(--terracotta)' }} />
      <span className="text-[13px] font-semibold text-[var(--terracotta)]">The team is on hold</span>
      <span className="text-[12px] text-[var(--ink-3)]">since {s.since} by {s.by} · {s.waiting} messages waiting · replies and post-op checks still go</span>
      <button type="button" className="ml-auto text-[12.5px] font-semibold text-[var(--ai-3)] hover:underline" onClick={() => { resumeTeam(); }}>Resume</button>
    </div>
  );
}
